const case1 = {
  "title": "Document non validé et non complet",
  "text": "Vous allez partager un document non complet et non validé à une personne extérieure.",
  "question": "Etes-vous sûr de vouloir continuer ?",
  "cancelLabel": "Annuler",
  "confirmLabel": "Accéder au partage"
}

const case2 = {
  "title": "Document  non complet",
  "text": "Vous allez partager un document non complet à une personne extérieure.",
  "question": "Etes-vous sûr de vouloir continuer ?",
  "cancelLabel": "Annuler",
  "confirmLabel": "Accéder au partage"
}

const case3 = {
  "title": "Document non validé",
  "text": "Vous allez partager un document non validé à une personne extérieure.",
  "question": "Etes-vous sûr de vouloir continuer ?",
  "cancelLabel": "Annuler",
  "confirmLabel": "Accéder au partage"
}

const content = {
  "nonValidator": {
    "required": {
      "notValidatedNoTask": {
        "notCompleted": case1,
        "completed": case3,
      },
      "notValidatedTask": {
        "notCompleted": case1,
        "completed": case3,
      },
      "validated": {
        "notCompleted": case2
      }
    },
    "optional": {
      "notValidatedNoTask": {
        "notCompleted": case1,
        "completed": case3,
      },
      "notValidatedTask": {
        "notCompleted": case1,
        "completed": case3,
      },
      "validated": {
        "notCompleted": case2
      }
    },
  },
  "validator": {
    "required": {
      "notValidatedNoTask": {
        "notCompleted": case1,
        "completed": case3,
      },
      "notValidatedTask": {
        "notCompleted": case1,
        "completed": case3,
      },
      "validated": {
        "notCompleted": case2
      }
    },
    "optional": {
      "notValidatedNoTask": {
        "notCompleted": case1,
        "completed": case3,
      },
      "notValidatedTask": {
        "notCompleted": case1,
        "completed": case3,
      },
      "validated": {
        "notCompleted": case2
      }
    }
  }
}

export default content
